import styled from "styled-components";

export const TableHeader = styled.h2`
     padding: 1vh;
`